import { Component, OnInit } from "@angular/core";
import CryptoEs from 'crypto-es';
import {ActivatedRoute, Router} from "@angular/router";
import { environment } from '../../../environments/environment';
import { InstallationService } from "./services/installation.service";
import * as moment from "moment";

@Component({
  selector: 'openpay-installation-page',
  templateUrl: './installation-component.html',
  styleUrls: ['./installation-component.css']
})

export class InstallationPageComponent implements OnInit {
    idMerchant: string = '';
    privateKey: string = '';
    publicKey: string = '';
    callbackUrl: string = "#";
    code: string;
    registerData: string;
    params: string;
    storeId: string = "1934115";
    loader: boolean = false;
    successInstall: boolean = false;
    errorToast: boolean = false;
    errorSection: boolean = false;
    infoModal: boolean = false;
    regressiveTime: number = 10;
    statusSend = false;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private installationService: InstallationService
    ){}
    ngOnInit(): void {
        this.handleQueryParams();
        this.validateTimeOfCode()
    }

      private handleQueryParams(){
        this.code = this.route.snapshot.queryParamMap.get("code")
        this.registerData = this.route.snapshot.queryParamMap.get("registerData")
        let parameters = this.route.snapshot.queryParamMap.get("params").replace(/ /g, '+');
        const parametersDecrypted = this.decryptData(parameters);
        let [storeId, callbackUrl] = parametersDecrypted.split("|");
        this.storeId = storeId;
        this.callbackUrl = callbackUrl;
    }

      private validateTimeOfCode = () => {
        if(!this.code){
        this.router.navigate(['not-found']).then()
          return
        }
        let codeValue = this.base64DecodeUnicode(this.code)
        let [time, place] = codeValue.split('-')
        if((moment().utc(true).valueOf() - (30 * 1000)) > +time){
          this.router.navigate(['not-found']).then()
        }

        if(place !== 'welcome'){
          this.router.navigate(['not-found']).then()
        }
      }

      goToCallbackUrl() {
        window.location.href = this.callbackUrl.includes("http") ? this.callbackUrl : this.base64DecodeUnicode(this.callbackUrl);
      }

      goToRegister(){
        switch (this.registerData){
          case 'MX': window.open( environment.registerUrlMx);
          break;
          case 'CO': window.open(environment.registerUrlCo);
          break;
          case 'AR': window.open(environment.registerUrlAr);
          break;
        }
      }

    base64DecodeUnicode (str){
        let percentEncodedStr = atob(str).split('').map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join('');
        return decodeURIComponent(percentEncodedStr);
    }

    encryptData(){
        if(this.idMerchant == '' || this.publicKey == '' || this.privateKey == ''){
            this.statusSend = true;
            return;
        } else {
            this.statusSend = false;
        }
        const secret_key = environment.secret_key;

        let merchantData = {
            idMerchantOpenpay: this.idMerchant,
            publicKey: this.publicKey,
            privateKey: this.privateKey,
            countryCode: this.registerData,
            code: this.code
        }
        const iv = this.generateEncryptionIv(secret_key);
        const key = CryptoEs.enc.Base64.parse(secret_key);
        const encrypted = CryptoEs.AES.encrypt(JSON.stringify(merchantData), key, {
            iv: iv,
            mode: CryptoEs.mode.CBC,
            padding: CryptoEs.pad.Pkcs7
        });

        const encryptedMessage = iv.toString() + encrypted.ciphertext.toString(CryptoEs.enc.Hex);
      console.log(this.storeId);
        const body = {
            idMerchantReferenced: this.storeId,
            data: encryptedMessage
        }
        this.loader = true;
        this.installationService.saveCredentials(body).subscribe(response => {
            if(response.redirectUrl){
                this.loader = false;
                const redirectUrl = response.redirectUrl;
                if(redirectUrl.includes('success')){
                    this.successInstall = true;
                    sessionStorage.removeItem('install-attempts');
                    this.goToNuvemshopAutomatically();
                } else {
                    this.errorSection = true;
                }
            } else {
                this.loader = false;
                this.errorToast = true;
            }
        }, (error) => {
            this.loader = false;
            if(error.status == 422){
                this.showErrorToast()
                if(sessionStorage.getItem('install-attempts')){
                    let attempts = parseInt(sessionStorage.getItem('install-attempts'));
                    attempts = attempts + 1;
                    sessionStorage.setItem('install-attempts', attempts.toString());
                    if(attempts > 2){
                      this.errorSection = true;
                    }
                  } else {
                    sessionStorage.setItem('install-attempts', '1')
                  }
            } else {
                this.errorSection = true;
            }
        });
    }

    generateEncryptionIv(key){
        const hash = CryptoEs.SHA512(key);
        const hexString = hash.toString(CryptoEs.enc.Hex).substring(0,32);
        const encryptionIv = CryptoEs.enc.Hex.parse(hexString);
        return encryptionIv;
    }

    decryptData(data){
        const secret_key = environment.secret_key;
        const base64Message = data;
        const base64ToHex = CryptoEs.enc.Base64.parse(base64Message).toString(CryptoEs.enc.Hex);
        const messagehex = base64ToHex;
        const keyBase64 = secret_key;
        const key = CryptoEs.enc.Base64.parse(keyBase64);
        const iv = CryptoEs.enc.Hex.parse(messagehex.substring(0, 32));
        const encryptedMessage = CryptoEs.enc.Hex.parse(messagehex.substring(32));
        const decrypted = CryptoEs.AES.decrypt({
         ciphertext: encryptedMessage
        }, key, {
            iv: iv,
            mode: CryptoEs.mode.CBC,
            padding: CryptoEs.pad.Pkcs7
     });
     const decryptedText = decrypted.toString(CryptoEs.enc.Utf8);
     return decryptedText;
    }

    backToNuvemshop(){
        sessionStorage.removeItem('install-attempts');
        window.location.href = this.callbackUrl
    }

    showErrorToast(){
        this.errorToast = true;
        setTimeout(() => {
          this.errorToast = false;
        }, 6000);
      }

      closeInfoModal(){
        this.infoModal = false;
      }
      openInfoModal(){
        this.infoModal=true;
      }

      goToNuvemshopAutomatically(){
        let tiempoRestante = 10;
        const intervalo = setInterval(() => {
        this.regressiveTime = tiempoRestante;
        tiempoRestante--;

        if (tiempoRestante < 0) {
            clearInterval(intervalo);
            window.location.href = this.callbackUrl
        }
    }, 1000);

      }
}
